import React from 'react';

import { useTheme } from 'styled-components';
import { ThemeType } from 'theme/theme';

import { ReactComponent as TrashIcon } from 'assets/images/trash-can.svg';

import { Container, StyledButton, TextContainer, TrashIconContainer } from './styles';

export interface Props {
  value: string;
  onClick?: () => void;
  isEdition?: boolean;
}

const DeleteButton = ({ value, onClick, isEdition }: Props) => {
  const theme = useTheme() as ThemeType;

  return (
    <Container isEdition={isEdition}>
      <StyledButton type="button" onClick={onClick}>
        <TextContainer>
          {value}
          <TrashIconContainer>
            <TrashIcon stroke={theme.primaryBackgroundColor} />
          </TrashIconContainer>
        </TextContainer>
      </StyledButton>
    </Container>
  );
};

export default DeleteButton;
